import { render } from "./promo-code.component.vue?vue&type=template&id=620087ab&ts=true"
import script from "./promo-code.component.vue?vue&type=script&lang=ts"
export * from "./promo-code.component.vue?vue&type=script&lang=ts"

import "./promo-code.component.vue?vue&type=style&index=0&id=620087ab&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__